import { Link } from 'react-router-dom';
import { brandInfo } from '@/mocks/site';
import TailEdge from '@/components/base/TailEdge';

export default function Footer() {
  return (
    <footer className="relative bg-background-100">
      <TailEdge />
      <div className="mx-auto max-w-[1280px] px-5 md:px-8 lg:px-10 pt-12 md:pt-16 pb-6 md:pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-7 sm:gap-10 lg:gap-6">
          <div className="lg:col-span-4">
            <Link to="/" className="font-heading text-[28px] uppercase tracking-wide cursor-pointer">Redline<span className="text-primary-400"> Garage</span></Link>
            <p className="mt-3 sm:mt-4 text-sm leading-relaxed text-foreground-700 max-w-xs">Independent auto repair and maintenance workshop. Precise diagnostics, honest estimates, careful work.</p>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-foreground-600 mb-3 sm:mb-4"><a href="#footer-nav">Navigate</a></h4>
            <ul id="footer-nav" className="grid grid-cols-2 gap-x-4 gap-y-1 sm:block sm:space-y-2.5 text-sm">
              {[['/', 'Home'], ['/services', 'Services'], ['/about', 'About'], ['/contact', 'Contact & Booking']].map(([to, label]) => (
                <li key={to}><Link to={to} className="inline-flex items-center min-h-[40px] sm:min-h-0 text-foreground-800 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-foreground-600 mb-3 sm:mb-4"><a href="#footer-contact">Contact</a></h4>
            <ul id="footer-contact" className="space-y-2 sm:space-y-2.5 text-sm leading-[1.5] text-foreground-800">
              <li>{brandInfo.address}<br />{brandInfo.city}</li>
              <li><a href={brandInfo.phoneHref} className="hover:text-primary-400 transition-colors cursor-pointer">{brandInfo.phone}</a></li>
              <li><a href={`mailto:${brandInfo.email}`} className="hover:text-primary-400 transition-colors cursor-pointer break-all">{brandInfo.email}</a></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-foreground-600 mb-3 sm:mb-4"><a href="#footer-hours">Opening Hours</a></h4>
            <ul id="footer-hours" className="space-y-2 sm:space-y-2.5 text-sm">
              {brandInfo.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-4 border-b border-background-300/50 pb-2 sm:pb-2.5">
                  <span className="text-foreground-700">{h.day}</span>
                  <span className="text-foreground-900 whitespace-nowrap">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-9 sm:mt-12 pt-5 sm:pt-6 border-t border-background-300/60 flex flex-row flex-wrap items-center justify-between gap-3 sm:gap-4">
          <p className="text-xs text-foreground-600">© 2026 Redline Garage. All rights reserved.</p>
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="group inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-xs uppercase tracking-[0.16em] text-foreground-700 hover:text-foreground-950 whitespace-nowrap cursor-pointer">
            Back to top
            <span className="w-8 h-8 flex items-center justify-center border border-background-300 rounded-md group-hover:border-primary-500 group-hover:bg-primary-500 transition-colors"><i className="ri-arrow-up-line" /></span>
          </button>
        </div>
      </div>
    </footer>
  );
}